/**
 * Pre-order button logic based on variant metafield custom.show_pre_order_button.
 *
 * When a variant has show_pre_order_button == 1, the buy button text is set to
 * the value of custom.pre_order_button_text (or falls back to theme.variantStrings.preOrder).
 * The state is updated on every variant change via the native "variant:change" event.
 */

(function () {
  'use strict';

  function getVariantData(sectionId, productId) {
    const block = document.getElementById(`PreOrderData-${sectionId}-${productId}`);
    if (!block) return null;
    try {
      return JSON.parse(block.textContent);
    } catch {
      return null;
    }
  }

  function getSubmitButton(sectionId, productId) {
    const form = document.getElementById(`ProductForm-${sectionId}-${productId}`);
    return form ? form.querySelector('[type="submit"][name="add"]') : null;
  }

  /**
   * Update the button text for the given variant.
   * Skips update when the button is disabled (sold out / unavailable).
   */
  function applyPreOrderState(button, variantData, variantId) {
    if (!button || !variantData) return;

    // Do not override sold-out / disabled state
    if (button.disabled) return;

    const entry = variantData.variants.find((v) => v.id === variantId);
    if (!entry) return;

    const textSpan = button.querySelector('.btn-text > span');
    if (!textSpan) return;

    if (entry.showPreOrder == 1) {
      const label =
        entry.preOrderText && entry.preOrderText.length > 0
          ? entry.preOrderText
          : (window.theme && theme.variantStrings ? theme.variantStrings.preOrder : 'Pre-order');
      textSpan.textContent = label;
      button.setAttribute('data-pre-order', '');
    } else {
      // Restore default label only when button had been overridden by us
      if (button.hasAttribute('data-pre-order')) {
        textSpan.textContent =
          window.theme && theme.variantStrings ? theme.variantStrings.addToCart : 'Add to cart';
        button.removeAttribute('data-pre-order');
      }
    }
  }

  function initForBlock(dataBlock) {
    const sectionId = dataBlock.dataset.sectionId;
    const productId = dataBlock.dataset.productId;
    if (!sectionId || !productId) return;

    const variantData = getVariantData(sectionId, productId);
    if (!variantData) return;

    const button = getSubmitButton(sectionId, productId);
    if (!button) return;

    // --- Initial load: read selected variant from the picker's JSON blob ---
    const variantPicker = document.getElementById(`VariantPicker-${sectionId}-${productId}`);
    if (variantPicker) {
      try {
        const selectedVariantEl = variantPicker.querySelector('[data-selected-variant]');
        if (selectedVariantEl) {
          const selected = JSON.parse(selectedVariantEl.textContent);
          if (selected) applyPreOrderState(button, variantData, selected.id);
        }
      } catch {
        // Silently ignore parse errors on initial load
      }
    }

    // --- Dynamic update on variant change ---
    const productForm = document.getElementById(`ProductForm-${sectionId}-${productId}`);
    const eventTarget = productForm || document;

    eventTarget.addEventListener('variant:change', (event) => {
      const variant = event.detail && event.detail.variant;
      if (!variant) return;
      // Run after a microtask so theme's toggleSubmitButton runs first
      Promise.resolve().then(() => {
        applyPreOrderState(button, variantData, variant.id);
      });
    });
  }

  function init() {
    document
      .querySelectorAll('script[id^="PreOrderData-"][type="application/json"]')
      .forEach(initForBlock);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
